import { useState } from 'react';
import { API_BASE_URL } from './DispatcherApp';
import shonanPalmLogo from '../../assets/shonan-palm-gold-transparent.png';

export default function DispatcherLogin({ onLogin }) {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/dispatcher/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone, password })
      });

      // 先获取响应文本，避免重复读取 body
      const responseText = await response.text();
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (parseError) {
        // 响应不是有效 JSON
        if (!response.ok) {
          throw new Error(`登录失败 (${response.status})`);
        }
        throw new Error('服务器响应格式错误');
      }

      if (!response.ok) {
        throw new Error(data.detail || `登录失败 (${response.status})`);
      }

      onLogin(data.access_token, data.dispatcher);
    } catch (err) {
      console.error('[Dispatcher Login] Error:', err);
      setError(err.message || '登录失败，请检查手机号和密码');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dispatcher-luxury-portal flex min-h-screen items-center justify-center p-4">
      <div className="w-full max-w-md rounded-3xl border border-[#d8b76a]/26 bg-[linear-gradient(180deg,rgba(12,10,6,0.96),rgba(2,2,1,0.98))] p-8 shadow-[0_34px_100px_rgba(0,0,0,0.58)]">
        <div className="mb-8 flex justify-center">
          <div className="shonan-compact-brand shonan-compact-brand-centered">
            <div className="shonan-compact-brand-mark">
              <img
                src={shonanPalmLogo}
                alt="Shonan International"
                className="h-full w-full object-contain"
              />
            </div>
            <div className="shonan-compact-brand-copy">
              <p className="shonan-compact-brand-title">SHONAN INTERNATIONAL</p>
              <p className="shonan-compact-brand-subtitle">Private Transfer & Charter</p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          {error && (
            <div className="premium-chip-destructive px-4 py-3 rounded-lg text-sm">
              {error}
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-foreground mb-1.5">
              手机号
            </label>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="请输入手机号"
              className="premium-input"
              required
              data-testid="dispatcher-phone-input"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-1.5">
              密码
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="请输入密码"
              className="premium-input"
              required
              data-testid="dispatcher-password-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full premium-button bg-primary text-primary-foreground py-2.5 hover:brightness-110 disabled:opacity-50 disabled:cursor-not-allowed"
            data-testid="dispatcher-login-button"
          >
            {loading ? (
              <span className="flex items-center justify-center">
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                登录中...
              </span>
            ) : '登录'}
          </button>
        </form>

        <div className="mt-6 text-center text-sm text-muted-foreground">
          <p>如需开通账号，请联系管理员</p>
        </div>
      </div>
    </div>
  );
}
